import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyB9-VEv62YCkzZYkygdp4DFAAZymS7sbZw",
    authDomain: "studio-sharan.firebaseapp.com",
    projectId: "studio-sharan",
    storageBucket: "studio-sharan.firebasestorage.app",
    messagingSenderId: "703661584535",
    appId: "1:703661584535:web:08cfda6fd87fb9b09179d2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
